module.exports = __webpack_public_path__ + "img/hint.69271516.png";